
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getLocalizedSSRAxios } from "api";
import ProductDetail from "components/pages/ProductDetail";
import Layout from "components/layout/layout";
import { formattedDate } from "common/utils";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { DIRECT_PURCHASE_EXPIRATION_DAYS, DIRECT_PURCHASE_STORAGE_KEY, getProductIdToDirectPurchaseInfo, hasValidDirectPurchaseInfo } from "common/product";
import { setCountryCodeInCookieSSR } from "common/i18n";
const ProductDetailPage = (props) => {
    const { productData, forcedDirectPurchase, countryCode } = props;
    const product = productData ? productData.product : null;
    const router = useRouter();
    useEffect(() => {
        if (router?.query?.dp === 'true' && product?.id) {
            const productIdToValue = getProductIdToDirectPurchaseInfo();
            const expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + DIRECT_PURCHASE_EXPIRATION_DAYS);
            const newProductIdToValue = {
                ...productIdToValue,
                [parseInt(product.id)]: formattedDate(expirationDate)
            };
            window.localStorage.setItem(DIRECT_PURCHASE_STORAGE_KEY, JSON.stringify(newProductIdToValue));
        }
        else if (router?.query?.dp === 'false' && product?.id) {
            const productIdToValue = getProductIdToDirectPurchaseInfo();
            const newProductIdToValue = { ...productIdToValue };
            delete newProductIdToValue[parseInt(product.id)];
            window.localStorage.setItem(DIRECT_PURCHASE_STORAGE_KEY, JSON.stringify(newProductIdToValue));
        }
    }, [router?.query?.dp, product]);
    const isTopBannerHidden = (forcedDirectPurchase === true ?
        true :
        forcedDirectPurchase === false ?
            false :
            product ? product.is_direct_web_purchase_product || hasValidDirectPurchaseInfo(product.id) : false);
    return (<Layout isNavBarHidden={true} isTopBannerHidden={isTopBannerHidden}>
            <ProductDetail {...props} showSellerShopButton/>
        </Layout>);
};
async function getServerSideProps(context) {
    const { countryCode } = setCountryCodeInCookieSSR(context);
    let productData = null;
    let creator = null;
    let notFound = false;
    let error = false;
    const ccode = context.params.ccode;
    let creatorResult = null;
    try {
        console.log('getLocalizedSSRAxios before', countryCode);
        const axios = getLocalizedSSRAxios(countryCode);
        const productResult = axios.get(`v3/store/products/${context.params.pid}`, {
            params: { is_bot: true, referral_id: ccode },
            headers: { Cookie: context.req.headers.cookie || '' }
        });
        if (ccode) {
            creatorResult = axios.get(`v1/palette/creator/${ccode}`);
        }
        const res = await productResult;
        if (res.status === 200) {
            productData = res.data;
        }
        else if (res.status === 301) {
            const redirectUrl = res.data.extra?.redirect_url;
            if (redirectUrl) {
                return {
                    redirect: {
                        permanent: false,
                        destination: redirectUrl
                    }
                };
            }
            else {
                error = true;
            }
        }
        else if (res.status === 404) {
            notFound = true;
        }
        else {
            error = true;
        }
    }
    catch (e) {
        error = true;
    }
    try {
        if (creatorResult) {
            const res = await creatorResult;
            if (res.status < 400) {
                creator = res.data;
            }
        }
    }
    catch (e) {
    }
    return {
        props: {
            notFound: notFound,
            productData: productData,
            forcedDirectPurchase: context.query.dp === 'true' ? true : context.query.dp === 'false' ? false : null,
            creator: creator,
            ssrError: error,
            locale: context.locale,
            countryCode
        }
    };
}
export default ProductDetailPage;
ProductDetailPage.restoreScroll = true;

    async function __Next_Translate__getServerSideProps__1966fcd8fba__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/store/products/[pid]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1966fcd8fba__ as getServerSideProps }
  